import type { ContentEntity } from "shared/schema";
import { getItemID, splitEntity } from "shelving";
import { formatCompactNumber } from "shared/util/number";
import { RewardIcons } from "../reward/RewardIcon.js";
import { useQuery } from "../util/db.js";

/** Show the top three reactions for a target. */
export function ReactionCount({ count, target }: { count: number; target: ContentEntity }): React.ReactElement {
	const reactions = useQuery("reaction", { target, $order: "!count", $limit: 3 });
	const [type, id] = splitEntity(target);
	return (
		<a className="button button-quiet" href={`/reactions/${type}/${id}`}>
			{reactions.loading ? null : reactions.value.length ? <RewardIcons ids={reactions.value.map(getItemID)} type="reaction" /> : null}
			<span>{formatCompactNumber(count)}</span>
		</a>
	);
}
